/* =============================================================================
   ZEPHIR — el logo se teje al entrar (2026-09-03)
   =============================================================================
   Pedido: "al ingresar a la pagina puede verse grande y luego se posicione como
   esta ahorita en el main menu, que se arme como si fuera un hilo".

   COMO FUNCIONA, en tres tiempos:
     1. un HILO finisimo barre el logo de izquierda a derecha y va dejando las
        letras ya rellenas detras de si (clip-path sincronizado con el hilo)
     2. el hilo se apaga y el logo vuela y se encoge hasta su hueco de la cabecera
     3. el velo se retira mientras el logo vira a blanco, y cruza con el real

   SEGUNDA VERSION. La primera dibujaba el CONTORNO de las letras y luego lo
   rellenaba, y al cliente no le convencio ("no me gusta como solo esta trazo y
   despues se rellena"), aparte de que el relleno entrando de golpe era un salto.
   Ahora no hay fase de contorno: las letras estan rellenas desde el principio y
   lo que las descubre es el paso del hilo. Un solo barrido, sin escalones.

   CINCO DECISIONES QUE NO SON DE ADORNO
   -------------------------------------
   0. NADA DE PLUGINS: solo el nucleo de GSAP. DrawSVGPlugin ademas **da 404 en
      cdnjs** (comprobado: el nucleo responde 200), pero es que ya no hace falta:
      el descubrimiento se hace con `clip-path`, no trazando contornos.

   0b. EL CLON SE MONTA GRANDE Y SE REDUCE, NUNCA AL CONTRARIO. En la primera
      version la caja del clon media 80x30 -- la del logo de la cabecera -- y se
      agrandaba con `scale(6.4)`: el navegador rasteriza la capa a su tamano de
      maquetacion y luego estira el mapa de bits, asi que el logo se veia
      PIXELADO en grande (el cliente lo dijo). Ahora la caja se monta al tamano
      GRANDE y la animacion la ESCALA HACIA ABAJO hasta el hueco de la cabecera:
      reducir un mapa de bits se ve limpio, ampliarlo no.

   1. EL LOGO DEL TEMA ES UN <img> A UN .svg, asi que sus trazos no se pueden
      animar: hace falta el SVG EN LINEA. Se pide el archivo con fetch (se
      comprobo que el CDN de Shopify lo permite) y se clona en linea. Se pide en
      caliente y no se copia el SVG aqui A PROPOSITO: asi, si el cliente cambia
      el logo en los ajustes del tema, la animacion sigue usando el nuevo. Una
      copia pegada en este archivo se quedaria vieja sin que nadie se enterase.

   2. LAS LETRAS SON RELLENO, NO TRAZO. Un logo se dibuja con `fill`, y DrawSVG
      solo anima trazos. Asi que al clon se le quita el relleno y se le pone
      trazo (el contorno de las letras), se dibuja ese contorno, y despues se
      cruza al relleno. De ahi viene el efecto de hilo: lo que se ve trazarse es
      el perfil de cada letra. El trazo lleva `vector-effect: non-scaling-stroke`
      para que se mantenga finisimo -- como un hilo -- tanto en grande como en
      pequeno.

   3. NO SE ANIMAN width/left/top, SE ANIMA transform. El clon se coloca
      exactamente sobre el hueco real del logo y se le da el estado inicial
      "grande y centrado" con x/y/scale; la animacion solo lo devuelve a
      x:0 y:0 scale:1. Aterriza clavado en la cabecera, sin recalcular
      posiciones, y va por GPU.

   4. GSAP SE CARGA SOLO SI LA ANIMACION VA A OCURRIR. Son ~70 KB del nucleo: no
      tienen por que caer en todas las paginas ni en cada visita.
      Se comprueba primero que sea la portada, que no se haya visto ya en esta
      sesion y que el visitante no haya pedido menos movimiento.

   5. EL VELO NO EXISTE HASTA QUE TODO ESTA LISTO. Se crea desde JS y despues de
      que GSAP haya cargado, nunca en el HTML: si algo falla, no hay velo y la
      tienda se ve normal. Ademas hay un seguro por tiempo y la animacion se
      salta con cualquier clic, tecla o scroll -- nadie deberia quedarse mirando
      un logo si quiere comprar.
   ========================================================================== */
(function () {
  'use strict';

  var CLAVE = 'zephirLogoHilo';           // marca de "ya visto" en esta sesion
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/';
  var SEGURO_MARGEN_MS = 1200;            // margen del seguro sobre la duracion real

  /* INTERRUPTOR DE VISTA PREVIA, pensado para el cliente y para depurar:
       ?zphHilo=1      -> la vuelve a lanzar aunque ya se haya visto en la sesion
       ?zphHilo=slow   -> ademas la pone a un cuarto de velocidad
       ?zphHilo=0.35   -> la CONGELA en ese punto (0 a 1) para poder mirarla;
                          con un clic sigue y termina
     Sin el parametro no cambia nada, asi que puede quedarse en produccion: es
     la unica forma de ensenarla dos veces seguidas sin cerrar la pestana. */
  var previa = (function () {
    var m = /[?&]zphHilo=([^&]*)/.exec(location.search);
    return m ? decodeURIComponent(m[1]) : null;
  })();

  /* --- filtros de entrada ------------------------------------------------ */

  function debeCorrer() {
    if (!document.body.classList.contains('template-index')) return false;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (previa) return true;              // el interruptor manda
    try { if (sessionStorage.getItem(CLAVE)) return false; } catch (e) { /* modo privado */ }
    return true;
  }

  function marcarVisto() {
    try { sessionStorage.setItem(CLAVE, '1'); } catch (e) {}
  }

  /* --- cargar GSAP solo cuando hace falta -------------------------------- */

  function cargar(src) {
    return new Promise(function (ok, mal) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = ok;
      s.onerror = mal;
      document.head.appendChild(s);
    });
  }

  function traerGsap() {
    if (window.gsap) return Promise.resolve();
    return cargar(CDN + 'gsap.min.js');
  }

  /* --- el SVG del logo, en linea ----------------------------------------- */

  function traerSvg(img) {
    var url = img.getAttribute('src') || img.dataset.src || '';
    if (!/\.svg(\?|$)/i.test(url)) return Promise.reject('el logo no es svg');
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
      var svg = doc.querySelector('svg');
      if (!svg) throw new Error('svg ilegible');
      return svg;
    });
  }

  /* --- la animacion ------------------------------------------------------ */

  function montar(img, svg) {
    var caja = img.getBoundingClientRect();
    if (!caja.width || !caja.height) return;

    var gsap = window.gsap;

    // La caja del clon se monta al TAMANO GRANDE y centrada; la animacion la
    // reduce hasta el hueco de la cabecera. Al contrario se veia pixelado.
    var vw = window.innerWidth, vh = window.innerHeight;
    var anchoGrande = Math.min(vw * 0.56, 520);
    var altoGrande = anchoGrande * (caja.height / caja.width);

    var clon = document.createElement('div');
    clon.className = 'zph-hilo__logo';
    clon.setAttribute('aria-hidden', 'true');
    clon.style.cssText = 'position:fixed;z-index:100000;pointer-events:none;' +
      'left:' + Math.round((vw - anchoGrande) / 2) + 'px;' +
      'top:' + Math.round((vh - altoGrande) / 2) + 'px;' +
      'width:' + anchoGrande + 'px;height:' + altoGrande + 'px;';

    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.style.cssText = 'width:100%;height:100%;display:block;overflow:visible';
    clon.appendChild(svg);

    var velo = document.createElement('div');
    velo.className = 'zph-hilo__velo';
    velo.setAttribute('aria-hidden', 'true');
    velo.style.cssText = 'position:fixed;inset:0;z-index:99999;background:#faf8f7;';

    document.body.appendChild(velo);
    document.body.appendChild(clon);
    img.style.visibility = 'hidden';

    // Las letras van RELLENAS desde el principio: sin fase de contorno y sin
    // relleno entrando de golpe, que era el escalon que no gustaba.
    var formas = [].slice.call(svg.querySelectorAll('path, polygon, rect, circle, ellipse, line'));
    formas.forEach(function (f) {
      f.style.fill = '#161616';
      f.style.fillOpacity = '1';
      f.style.stroke = 'none';
    });

    // El hilo: una linea finisima que barre el logo. Va DENTRO del clon, asi
    // que se mueve y se escala con el sin calculos aparte.
    var hilo = document.createElement('span');
    hilo.style.cssText = 'position:absolute;top:-6%;bottom:-6%;left:0;width:1px;' +
      'background:#161616;transform:translateX(-1px);will-change:transform';
    clon.appendChild(hilo);

    // Punto de llegada: el hueco real del logo. Se expresa como traslacion y
    // escala DESDE el centro de la pantalla, que es donde ya esta el clon.
    var escalaFinal = caja.width / anchoGrande;
    var xFinal = (caja.left + caja.width / 2) - vw / 2;
    var yFinal = (caja.top + caja.height / 2) - vh / 2;

    gsap.set(clon, { transformOrigin: '50% 50%' });
    gsap.set(svg, { clipPath: 'inset(0% 100% 0% 0%)' });

    /* EL COLOR FINAL NO ES EL DE PARTIDA, y esto se vio en una captura: el hilo
       se dibuja en tinta porque el velo es claro, pero aterriza sobre la foto
       del hero, donde el logo del tema es BLANCO -- al 87% de la animacion el
       clon era invisible, tinta sobre foto oscura.
       La senal la da el propio tema: le pone la clase `t4s-logo--tr-w`
       ("transparent white") al logo cuando toca la version blanca. Asi que se
       vira a blanco durante el vuelo, y al final se cruza con el logo real para
       que el relevo no se note aunque el color no coincida al pixel. */
    var haciaBlanco = img.classList.contains('t4s-logo--tr-w') &&
      document.documentElement.classList.contains('is--header-transparent');
    var colorFinal = haciaBlanco ? '#ffffff' : '#161616';

    var tl = gsap.timeline({

      onComplete: function () {
        img.style.visibility = '';
        clon.remove();
        velo.remove();
      }
    });

    /* 1. EL HILO BARRE Y VA DEJANDO LAS LETRAS.
          El barrido y el recorte van con la MISMA duracion y la MISMA curva,
          arrancando los dos en 0: asi el borde del recorte y el hilo van
          siempre pegados y parece que las letras salen de su paso. Una sola
          curva suave de principio a fin -- nada de escalones, que era la queja.
          Sin retardo entre letras: el escalonado hacia "tirones". */
    tl.to(hilo, { x: anchoGrande, duration: 1.15, ease: 'power2.inOut' }, 0);
    tl.to(svg, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.15, ease: 'power2.inOut' }, 0);
    // el hilo se apaga sin frenar, ya sobre el final del barrido
    tl.to(hilo, { autoAlpha: 0, duration: 0.4, ease: 'power1.out' }, 0.9);

    /* 2. VUELA Y SE ENCOGE hasta el hueco de la cabecera. `power2.inOut` y no
          `power3`: el tercer grado arranca y frena mas seco, y lo que se pidio
          es que fuese muy suave. */
    tl.addLabel('vuelo', '+=0.12');
    tl.to(clon, {
      x: xFinal, y: yFinal, scale: escalaFinal,
      duration: 1.05, ease: 'power2.inOut'
    }, 'vuelo');
    tl.addLabel('aterriza');

    /* 3. EL ORDEN IMPORTA, se vio en captura: si el velo se retira AL MISMO
          TIEMPO que el logo vira a blanco, hay un instante de blanco sobre
          fondo claro y el logo se esfuma. Primero aterriza en tinta sobre el
          velo y solo entonces el velo se va mientras la letra se aclara: el
          fondo se oscurece justo cuando la letra se aclara. */
    if (haciaBlanco) {
      tl.to(formas, { fill: colorFinal, duration: 0.45, ease: 'power1.inOut' }, 'aterriza');
    }
    tl.to(velo, { autoAlpha: 0, duration: 0.7, ease: 'power2.inOut' }, 'aterriza');

    // 4. relevo: aparece el logo de verdad y el clon se desvanece encima
    tl.add(function () { img.style.visibility = ''; });
    tl.to(clon, { autoAlpha: 0, duration: 0.25, ease: 'power1.out' });

    /* --- interruptor de vista previa ----------------------------------- */
    // Se aplica AQUI, con la linea de tiempo ya construida, y NO en `onStart`:
    // llamar a progress() desde onStart es a mitad del primer render y deja las
    // animaciones sin aplicar -- medido, al 60% el trazo seguia sin moverse.
    var congelada = false;
    if (previa === 'slow') {
      tl.timeScale(0.25);
    } else {
      var punto = parseFloat(previa);
      if (previa && punto >= 0 && punto <= 1) {
        tl.pause();
        tl.progress(punto);
        congelada = true;
      }
    }

    /* --- salidas de emergencia ----------------------------------------- */

    function terminar() {
      tl.progress(1);                      // dispara onComplete y limpia
    }
    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, terminar, { once: true, passive: true });
    });
    // El seguro se calcula SOBRE LA DURACION REAL, no a ojo. Con un valor fijo
    // de 4 s cortaba la animacion a medias en cuanto se ralentizaba con
    // ?zphHilo=slow -- que es justo cuando uno quiere verla entera.
    // En modo congelado NO se arma: el seguro salta a los pocos segundos y
    // termina la animacion, que es justo lo que se quiere evitar al mirarla
    // detenida. (Paso dos veces antes de darme cuenta.)
    if (!congelada) {
      var techo = (tl.totalDuration() / (tl.timeScale() || 1)) * 1000 + SEGURO_MARGEN_MS;
      setTimeout(function () {
        if (tl.progress() < 1) terminar();
      }, techo);
    }
  }

  /* --- arranque ---------------------------------------------------------- */

  function iniciar() {
    if (!debeCorrer()) return;
    // EL LOGO VISIBLE, no el primero. El tema pinta TRES copias del mismo
    // archivo -- normal, sticky y movil -- y las esconde por CSS segun el ancho.
    // Coger `querySelector` a secas devuelve la de escritorio, que en movil mide
    // 0x0: la animacion se quedaba esperando medidas y no llegaba a correr. Con
    // el 80% del trafico en movil, eso era dejarla fuera de donde mas se ve.
    function logoVisible() {
      var todos = document.querySelectorAll('.t4s-header__logo img');
      for (var i = 0; i < todos.length; i++) {
        var r = todos[i].getBoundingClientRect();
        if (r.width > 4 && r.height > 4) return todos[i];
      }
      return null;
    }
    var img = logoVisible();
    if (!img) return;

    marcarVisto();                         // si algo falla, no se reintenta en bucle

    // El logo puede llegar por lazyload: se espera a que tenga medidas.
    var intentos = 0;
    (function esperar() {
      var actual = logoVisible();
      if (actual) img = actual;            // puede cambiar al redimensionar
      var caja = img.getBoundingClientRect();
      if (caja.width && caja.height) {
        Promise.all([traerGsap(), traerSvg(img)])
          .then(function (res) { montar(img, res[1]); })
          .catch(function (e) {
            // Que no sea mudo: la tienda se ve normal igual, pero un fallo
            // silencioso aqui cuesta mucho de diagnosticar despues.
            if (window.console) console.warn('[zephir] logo-hilo:', e);
          });
        return;
      }
      if (++intentos < 40) setTimeout(esperar, 100);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
